import { Stack, Text } from '@fluentui/react';
import React, { useMemo } from 'react';

const NavBarItem = (props) => {

    const {
        active = false,
        disabled = true,
        numero = "",
        nomCommercial = "",
        onClick = (event) => console.log(event)
    } = props;

    const styles = useMemo(
        () => {
            return {
                outer: {
                    root: {
                        borderBottom: active ? "2px solid red" : "none",
                        cursor: disabled ? "cursor" : "pointer",
                        paddingBottom: 14,
                        minWidth: 240,
                        maxWidth: 240,
                    }
                },
                text: {
                    root: {
                        color: disabled ? "lightgrey" : "unset",
                        fontSize: 16,
                        fontWeight: active ? 600 : 400,
                        lineHeight: "19px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    }
                },
            };
        },
        [active, disabled]
    );

    return <Stack styles={styles.outer} onClick={disabled ? undefined : onClick}>
        <Text styles={styles.text}>{numero}</Text>
        <Text styles={styles.text}>{nomCommercial}</Text>
    </Stack>;

};

export default NavBarItem;